module.exports = __webpack_public_path__ + "img/home-15.fc88057a.webp";